/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFiles, addUploadingSlot, updateFile, updateStatus, ensureInstanceInitialized } from './documentoSlice';
import { subeDocumento } from './documentoAPI';
import { addDocumentoToActuacion } from '../expedienteSlice';

export default function SubirDocumento({ actuacionIndex = 'new' }) {
    const dispatch = useDispatch();
    
    const filesState = useSelector(selectFiles);
    const instance = filesState[actuacionIndex] || { files: [], loadingStatuses: [] };
    const { files, loadingStatuses } = instance;
    
    // Ensure the instance is initialized in Redux
    useEffect(() => {
        dispatch(ensureInstanceInitialized({ which: actuacionIndex }));
    }, [dispatch, actuacionIndex]);
    
    async function uploadFile(ref) {
        if (!ref) {
            return;
        }
        
        // Add a new uploading slot
        const index = files.length;
        dispatch(addUploadingSlot({ which: actuacionIndex }));
        
        const formData = new FormData();
        formData.append('documento', ref);

        try {
            const response = await subeDocumento(formData);
            if (response.ok) {
                const filename = await response.text();
                const normalizedFilename = filename.replace('\\', '/');
                dispatch(updateFile({
                    which: actuacionIndex,
                    index,
                    file: normalizedFilename
                }));
                dispatch(updateStatus({ 
                    which: actuacionIndex,
                    index,
                    loadingStatus: 'success'
                }));
                // Update expediente state if actuacionIndex is a number
                if (typeof actuacionIndex === 'number') {
                    dispatch(addDocumentoToActuacion({
                        actuacionIndex,
                        documento: normalizedFilename
                    }));
                }
            } else {
                const e = await response.text();
                throw new Error(e);
            }
                
        } catch (error) {
            dispatch(updateStatus({
                which: actuacionIndex,
                index,
                loadingStatus: 'error: '+error 
            }));
        }
    }
    
    async function onClickHandler(e) {
        e.preventDefault();
        const input = document.getElementById(`documento_actuacion_${actuacionIndex}`);
        if (input.files){
            await uploadFile(input.files[0]);
            input.value = ''; // Clear the input for next selection
        }
    } 


    return (
        <div className='docform'>
            <div>
                {files.map((file, index) => (
                    <div key={index} style={{marginBottom: '8px'}}>
                        {loadingStatuses[index] === 'uploading' && (
                            <span>⏳ Cargando documento...</span>
                        )}
                        {loadingStatuses[index]?.startsWith('error') && (
                            <span>❌ No se pudo cargar el documento.</span>
                        )}
                    </div>
                ))}
            </div>
            <div style={{marginTop: '8px'}}>
                <input type="file" id={`documento_actuacion_${actuacionIndex}`} name={`documento_actuacion_${actuacionIndex}`}/>
                <button type="button" onClick={onClickHandler}>Agregar documento</button>
            </div>
        </div>
    );
}